import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SizeTracker } from '../../../common/SizeTracker'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { CONNECT_MAP_TYPE, GRAPH_TYPE } from '../../constant'
import { convertBase64ToFile } from '../../helper'
import {
  changeFilter,
  changeLoading,
  changeRequestCode,
  resetState,
  selectFilter,
  selectRequestIds,
} from '../store/slice'
import { uploadFileConnectMap } from '../store/thunk'
import InvesteeMapTab from './InvesteeMapTab'
import LegalBeneficialTab from './LegalBeneficialTab'
import RadialMapTab from './RadialMapTab'
import Tab from './Tab'
import TopComponent from './TopComponent'
import classes from './index.module.scss'

const Content = () => {
  const dispatch = useDispatch()
  const filterBy = useSelector(selectFilter('filterBy'))
  const graphType = useSelector(selectFilter('graphType'))
  const dataFilter = useSelector(selectFilter())
  const requestIds = useSelector(selectRequestIds)

  const [activeTab, setActiveTab] = useState(graphType)
  const [mountedTabs, setMountedTabs] = useState([graphType])

  const getHiddenStyle = (type) => ({
    opacity: activeTab === type ? 1 : 0,
    position: activeTab === type ? 'relative' : 'absolute',
    pointerEvents: activeTab === type ? 'auto' : 'none',
    width: '100%',
    height: '100%',
    transition: 'opacity 0.3s ease',
  })

  const handleChangeTab = (key) => {
    dispatch(
      changeFilter({
        graphType: key,
      }),
    )
    setActiveTab(key)
    if (!mountedTabs.includes(key)) {
      setMountedTabs((prev) => [...prev, key])
    }
  }

  const renderContent = () => {
    return (
      <SizeTracker
        renderTopComponent={() => <TopComponent dataFilter={dataFilter} />}
      >
        {(size) => {
          return (
            <div
              className="positionRelative h100"
              style={{ height: `calc(100% - ${size.height}px)` }}
            >
              {mountedTabs.includes(GRAPH_TYPE.RADIAL_MAP) && (
                <div style={getHiddenStyle(GRAPH_TYPE.RADIAL_MAP)}>
                  <RadialMapTab
                    filterBy={filterBy}
                    filter={{ ...dataFilter, graphType: GRAPH_TYPE.RADIAL_MAP }}
                  />
                </div>
              )}

              {mountedTabs.includes(GRAPH_TYPE.LEGAL_BENEFICIAL) && (
                <div style={getHiddenStyle(GRAPH_TYPE.LEGAL_BENEFICIAL)}>
                  <LegalBeneficialTab
                    filterBy={filterBy}
                    filter={{
                      ...dataFilter,
                      graphType: GRAPH_TYPE.LEGAL_BENEFICIAL,
                    }}
                  />
                </div>
              )}

              {mountedTabs.includes(GRAPH_TYPE.INVESTEE_MAP) && (
                <div style={getHiddenStyle(GRAPH_TYPE.INVESTEE_MAP)}>
                  <InvesteeMapTab
                    filterBy={filterBy}
                    filter={{
                      ...dataFilter,
                      graphType: GRAPH_TYPE.INVESTEE_MAP,
                    }}
                  />
                </div>
              )}
            </div>
          )
        }}
      </SizeTracker>
    )
  }

  useEffect(() => {
    setActiveTab(GRAPH_TYPE.RADIAL_MAP)
    dispatch(resetState())
  }, [])

  useEffect(() => {
    window.hswidget_handleShowStatus = (data) => {
      if (data?.data?.base64String) {
        const fileType = data?.data?.fileType || 'pdf'
        const nameFile =
          [
            'FG',
            CONNECT_MAP_TYPE[activeTab],
            formatDateTime(new Date(), FORMAT.FILE_DOWNLOAD),
          ].join('_') +
          '.' +
          fileType
        const file = convertBase64ToFile(
          data?.data?.base64String,
          nameFile,
          fileType,
        )
        dispatch(uploadFileConnectMap(file))
      } else {
        //không thay đổi key widget này
        const mapType = {
          LBO: GRAPH_TYPE.LEGAL_BENEFICIAL,
          Investee: GRAPH_TYPE.INVESTEE_MAP,
          Radial: GRAPH_TYPE.RADIAL_MAP,
        }
        const graphTypeData = data?.data?.graph?.graphType
        const graphTypeMatch = mapType?.[graphTypeData]
        if (!graphTypeMatch) return
        dispatch(changeLoading({ [graphTypeMatch]: false }))
        const requestId = requestIds[graphTypeMatch]
        const originEntities = data?.data?.originEntities?.[0]?.id
        dispatch(changeRequestCode(originEntities))
        // dispatch(
        //   updateConnectionMapLogs({
        //     requestId,
        //     responseStatusCode: data?.code,
        //     responseMessage: data?.message,
        //     responseNodeCount: data?.data?.graph?.nodes.length,
        //     responseEdgeCount: data?.data?.graph?.edges?.length,
        //   }),
        // )
      }
    }

    return () => {
      delete window.hswidget_handleShowStatus
    }
  }, [activeTab])

  return (
    <>
      <SizeTracker
        renderTopComponent={() => (
          <Tab
            activeTab={activeTab}
            handleChangeTab={handleChangeTab}
            tabClassName={
              dataFilter?.searchCompany?.organizationId ||
              dataFilter?.searchPerson?.personId
                ? ''
                : classes.disableTabList
            }
          />
        )}
      >
        {(size) => {
          return (
            <div
              className="positionRelative h100"
              style={{ height: `calc(100% - ${size.height}px)` }}
            >
              {renderContent()}
            </div>
          )
        }}
      </SizeTracker>
    </>
  )
}

export default Content
